import React, {FunctionComponent} from "react";
import {useIntl} from "react-intl";
import {RouteProps} from "react-router-dom";
import Layout from "../components/layout/Layout";
import PageTitle from "../components/molecules/header/PageTitle";
import {Col} from "reactstrap";
import OrderItemsFormList from "../components/molecules/list/OrderItemsFormList";
import {OrderItemReferenceValue} from "../interfaces/OrderItemInterfaces";

const OrderItemFormListView: FunctionComponent<RouteProps> = () => {
  const intl = useIntl()
  const [referenceType, setReferenceType] = React.useState<OrderItemReferenceValue>(OrderItemReferenceValue.DESCRIPTION)

  return (
    <Layout>
      <div className="epow-content-body d-flex flex-column epow-order-form">
        <div className="d-flex mb-5">
          <Col xs={16}>
            <PageTitle pageTitle={intl.formatMessage({id: referenceType === OrderItemReferenceValue.DESCRIPTION ? "order_items_form_title_description" : "order_items_form_title_price" })}></PageTitle>
          </Col>
        </div>

        <OrderItemsFormList referenceType={referenceType} setReferenceType={setReferenceType} />
      </div>
    </Layout>
  )
}

export default OrderItemFormListView;
